import { Component, Input, OnInit, ViewEncapsulation, ViewChild, ElementRef,ContentChild,
        TemplateRef, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter,
        AfterViewInit, HostListener, NgZone,
        ChangeDetectorRef} from '@angular/core';
import { DataType } from '@core/models/enums';
import { cloneDeep, isEqual } from 'lodash';
import { GridConfigModel, GridGroupDataModel, GridHeaderModel, HeaderItemModel } from '@core/models/models';
import { COMPONENT_NAME, ComponentMap } from './grid-helper';
import { FullscreenService } from '@core/services/common';
import { IntervalHelper } from '@core/helper/interval.helper';
import { ShowcaseSyncService } from '@core/services/common/showcase-timer.service';
import { debounceTime } from 'rxjs/operators';
import { OfficeType } from '@core/constants';
import { BatheHelper } from '@modules/bathe-management/bathe.helper';
import { DpadControlService } from '@core/services/common/dpad-control.service';
@Component({
  selector: 'caremoni-grid-data',
  templateUrl: './grid-data.component.html',
  styleUrl: './grid-data.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class GridDataComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @ContentChild('body', { static: true }) bodyTemplate!: TemplateRef<any>;
  @ViewChild('grid', { read: ElementRef, static: false }) grid: ElementRef|undefined;
  private _gridHeader: GridHeaderModel[] = [];
  private _gridData: any[] = [];
  isChangeHeader: boolean = false;
  currentHeader: GridHeaderModel[] = [];
  isChecksheetScreen: any;
  @Input() isUserDashboard: boolean = false;
  @Input() isBathScheduleScreen: boolean = false;
  @Input() officeType: OfficeType = OfficeType.newTsusho;
  @Input() processShortTerm: boolean = false;
  @Input()
  set gridHeader(value: GridHeaderModel[]) {
    this._gridHeader = value || [];
    if(this._gridHeader?.length > 0) this.isChangeHeader = !isEqual(this.currentHeader, this._gridHeader);
    // nếu có thay đổi thì gán currentConfig = gridConfig
    if(this.isChangeHeader) {
      this.currentHeader = cloneDeep(value);
      // chỉ render header lần đầu or những lần thay đổi thông tin header
      this.generateHeader(); 
    }
  }

  originData: any[] = [];
  @Input() set gridData(data: any[]) {
 
    this._gridData = data || [];
    this.originData = cloneDeep(this._gridData || []);
  }
  @Input() gridConfig?: GridConfigModel = new GridConfigModel();
  @Output() displayPagination: EventEmitter<{pageNum: number, totalPage: number}> =  new EventEmitter<{pageNum: number, totalPage: number}>()
  @Output() onTriggerSortData: EventEmitter<any> =  new EventEmitter<any>()

  constructor(
    private cdr: ChangeDetectorRef,
    private fullScreenService: FullscreenService,
    private sync: ShowcaseSyncService,
    private dpadControlService: DpadControlService,
    private zone: NgZone,
  ) { }
  componentMap: any =  ComponentMap;
  DataType = DataType;
  headerMerges: any[] = [];
  pageSizeDefault: number = 10;
  gridConfigData: any = {
    // Chiều cao động của từng dòng header
    headerHeights: [], 
    // Chiều cao cơ bản của một dòng header
    headerRowHeight: 30, 
    headerTextColor: "white",
    headerBackgroundColor: "none",
    headerBorder: 'none',
    cellBorder: 'none',
    width: "100%",
    height: "100%",
  };
  isHeaderIncludeIcon: boolean = false;
  currentConfig: GridConfigModel = new GridConfigModel();
  groupItemSize: number = 0;
  allGrouplabelHeight: number = 0;
  headers: HeaderItemModel[][] = [];
  bodyData: any[][]= [];

  gridTemplateColumns = '';
  groupedData: GridGroupDataModel[] = [];
  // gắn cờ group data cho grid
  isGroupData: boolean = false;
  groupHeaderStyle: any = null;
  isFullscreen: boolean = false;
  intervalHelper = new IntervalHelper();;
  cellHeight = "0px"
  subscribeFullscreenState:any;
  subscribeisLockPage:any;
  private gridResizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    this.calcCellHeight();
    Promise.resolve().then(() => {
      this.sync.start(5000, true);
    });
    // .grid-wrapper's height tracks the browser chrome live via the .csh-body CSS
    // (dvh: toolbar collapse, tab-count change, orientation), but cellHeight is a
    // JS-baked px value — resync it on every real box-size change of the wrapper
    // itself, rather than guessing which window/visualViewport events matter.
    // ResizeObserver isn't zone.js-patched, so re-enter Angular's zone explicitly,
    // otherwise the recalculated cellHeight updates the property but never reaches
    // the [style.height] binding in the view.
    if (this.grid?.nativeElement) {
      this.gridResizeObserver = new ResizeObserver(() => {
        this.zone.run(() => this.calcCellHeight());
      });
      this.gridResizeObserver.observe(this.grid.nativeElement);
    }
  }

  // lấy chiều cao cuả group header
  getHeightOffGroupLabel(): number {
    const defaultHeight: number = window.innerHeight * 0.028; // 2.8vh
    let groupLabels = document.getElementsByClassName('grp-lbl');
    let height: number = 0;
    if(!groupLabels || groupLabels.length == 0) return defaultHeight;
    let cell = groupLabels[0] as HTMLElement;
    height = cell.offsetHeight;
    return height;
  }

  isFirstUpdatePage: boolean = false;
  // tính số item trên 1 page khi có group data
  getGroupItemInPage() {
    // Kiểm tra nếu grid không tồn tại hoặc chiều cao của grid bằng 0 thì thoát khỏi hàm
    if (!this.grid || (this.grid.nativeElement?.offsetHeight ?? 0) === 0) return;
    // Tính tổng chiều cao của header dựa trên số lượng header và chiều cao của từng header row
    const headerOffsetHeight = this.gridConfigData.headerRowHeight * this.headers.length;
    // Lấy tổng chiều cao của grid
    const totalHeight = this.grid.nativeElement?.offsetHeight ?? 0;
    // Tính chiều cao mặc định của mỗi hàng (không có group header)
    const defaultRowHeight = (totalHeight - headerOffsetHeight) / this.pageSizeDefault;
  
    // Lấy danh sách toàn bộ dữ liệu từ gridConfig
    let groupItems = this._gridData || [];
    if(groupItems.length == 0) return [];
  
    // Lấy chiều cao của một group label (header group)
    let groupLabelHeight = this.getHeightOffGroupLabel();
    // Hàm tính tổng chiều cao bị chiếm bởi các group header
    const calculateGroupHeight = (items: any[]) => 
      new Set(items.slice(0, this.pageSizeDefault).map(item => item.groupName)).size * groupLabelHeight;
    // Tính tổng chiều cao của tất cả group label trong dữ liệu ban đầu
    this.allGrouplabelHeight = calculateGroupHeight(groupItems);
    const maxGroupPageSize = 8;
    const calculatePageSize = this.pageSizeDefault - Math.floor(this.allGrouplabelHeight / defaultRowHeight);
    const pagesizeForGroup = calculatePageSize > maxGroupPageSize ? maxGroupPageSize : calculatePageSize;
    // Tính số lượng item có thể hiển thị trên một trang sau khi trừ đi phần chiếm chỗ của group header
    this.groupItemSize = pagesizeForGroup;
    if(this.gridConfig) this.gridConfig.pageSize = pagesizeForGroup;
    const currentPageForGroup = this.gridConfig?.currentPage || 0;
    const startIndex = (currentPageForGroup - 1) * pagesizeForGroup;
    const endIndex = startIndex + pagesizeForGroup;
    // Cắt danh sách dữ liệu để chỉ lấy các phần tử nằm trong giới hạn số lượng item có thể hiển thị
    groupItems = groupItems.slice(startIndex, endIndex);
    this.updatePagination();
    // Cập nhật lại tổng chiều cao của group label sau khi lọc dữ liệu
    this.allGrouplabelHeight = calculateGroupHeight(groupItems);
    // Trả về danh sách các item sau khi đã tính toán lại
    return groupItems;
  }

  updatePagination(): void {
   if(!this.isFirstUpdatePage && this.isGroupData) {
      // Kiểm tra config và dữ liệu đầu vào hợp lệ
      if (!this.gridConfig || !this.originData || !Array.isArray(this.originData) || this.groupItemSize == 0) return;
      // Gán số item mỗi trang
      this.gridConfig.pageSize = this.groupItemSize;
      // Tính tổng số trang
      this.gridConfig.totalPage = Math.ceil(this.originData.length / this.gridConfig.pageSize);
      // Emit event phân trang (duy nhất một lần)
      const currentPage = this.gridConfig.currentPage || 1;
      const totalPage = this.gridConfig.totalPage || 1;
      this.displayPagination.emit({ pageNum: currentPage, totalPage });
      this.isFirstUpdatePage = true;
   } 
   else if (this.isGroupData) {
      if (!this.gridConfig || !this.originData || !Array.isArray(this.originData) || this.groupItemSize == 0) return;
      this.gridConfig.totalPage = Math.ceil(this.originData.length / this.gridConfig.pageSize);
      const currentPage = this.gridConfig.currentPage || 1;
      const totalPage = this.gridConfig.totalPage || 1;
      this.displayPagination.emit({ pageNum: currentPage, totalPage });
   }
  }  

  calcCellHeight() {
    if(!this.grid || (this.grid.nativeElement?.offsetHeight ?? 0) == 0) return;
    let cellHeight: string = 'auto';
    const headerLevel = this.headers.length;
    // chiều cao của grid
    let gridHeight: number = this.grid.nativeElement?.offsetHeight;
    // tính chiều cao của header
    const headerOffsetHeight = this.gridConfigData.headerRowHeight * headerLevel;
    if(this.isGroupData) {
      // chiều cao của grid khi trừ đi header
      gridHeight = gridHeight - headerOffsetHeight;
      // chiều cao của grid khi trừ đi chiều cao của headerGroup
      gridHeight = gridHeight - this.allGrouplabelHeight;
      // lấy chiều cao của grid chia đều cho các item
      cellHeight = `${gridHeight/this.groupItemSize}px`;
      this.cellHeight = cellHeight;
    }
     // Update cell height
    else {
      cellHeight = `${(gridHeight - headerOffsetHeight)/(this.gridConfig?.pageSize || 1)}px`;
      this.cellHeight = cellHeight;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["gridConfig"] && changes["gridConfig"].currentValue) {
      this.bodyData = [];
      this.gridConfig = changes["gridConfig"].currentValue;
      this.isGroupData = this.gridConfig?.isGroupData? this.gridConfig.isGroupData : false;
      if(this.originData.length === 0) {
        this.groupedData = [];
        return;
      }
      if(!this.gridConfig?.isLockPage) {
        this.configGridSetting();
        this.paginationGridData();
      }
      else
      {
        this.intervalHelper.stopInterval('autoPaging');
        this.getDataInPage();
      }
    }

    if(this.isUserDashboard && changes["gridData"] && changes["gridData"].currentValue) {
        this.getDataInPage();
    }
  }

  ngOnInit(): void { 
    if(this.gridConfig) {
      this.gridConfigData.headerTextColor = this.gridConfig?.headerTextColor || 'white';
      this.gridConfigData.headerBorder = this.gridConfig?.headerBorder || 'none';
      this.gridConfigData.headerBackgroundColor = this.gridConfig?.headerBackgroundColor || 'none';
      this.subscribeisLockPage = this.fullScreenService.isLockPage$.subscribe((state: string) => {
        if (state === "init" || !state) return;
        if (this.gridConfig) this.gridConfig.isLockPage = state == "true" ? true : false;
        if(!this.gridConfig?.isLockPage) {
          this.paginationGridData(false);
        } else {
          this.intervalHelper.stopInterval('autoPaging');
        } 
      })
    }
    // lấy trạng thái isFullscreen
      this.subscribeFullscreenState = this.fullScreenService.fullscreenState$.pipe(debounceTime(200)).subscribe(state => {
      this.isFullscreen = state.isFullscreen;

      this.calcCellHeight();
      this.updateMinWidthTextMarquee();
    })
  }

  generateHeader() {
    // Nếu headers chưa có hoặc có thay đổi về header thì thực hiện khởi tạo lại
    if (!this.headers?.length || this.isChangeHeader) {
      // Gán lại headers từ 2 hàm getHeader và getSubHeader
      this.headers = [this.getHeader(), this.getSubHeader()];
      
      // Lấy ra danh sách header chính (dòng đầu tiên)
      const mainHeaders = this.headers[0] || [];
      // Chỉ lấy những cột đang hiển thị (có visible = true)
      const visibleHeaders = mainHeaders.filter(h => h?.visible);
      // Tính toán lại width cho từng cột hiển thị mỗi khi header có sự thay đổi
      this.calculateHeaderWidths(visibleHeaders);
      // Gộp các giá trị width thành 1 chuỗi dùng cho grid-template-columns
      this.gridTemplateColumns = visibleHeaders.map(x => x.width ?? 'auto').join(' ');
      // Lấy thông tin các header bị merge và clone sâu để tránh ảnh hưởng dữ liệu gốc
      this.headerMerges = cloneDeep(this.getMergedHeaders());
      const cells: any[] = this.headerMerges?.flatMap(r => r) || [];
      this.isHeaderIncludeIcon = cells?.some(c => c?.value?.[0]?.imgUrl);
    }
  }

  calculateHeaderWidths(headers: any[]) {
    // Kiểm tra headers hợp lệ
    if (!Array.isArray(headers) || headers.length === 0) return;
  
    // Lấy chiều rộng thực tế của grid hoặc fallback là chiều rộng cửa sổ
    const gridWidth = this.grid?.nativeElement?.offsetWidth || window.innerWidth;
  
    // Lọc ra các cột được hiển thị
    const visibleHeaders = headers.filter(h => h?.visible);
    if (visibleHeaders.length === 0) return;
  
    // Tìm tất cả các cột có width = 'auto'
    const autoCols = visibleHeaders.filter(h => h.width === 'auto') || [];
  
    // Biến lưu tổng phần trăm hiện tại
    let totalPercent = 0;
  
    // Chuyển các đơn vị khác về % so với gridWidth
    const getWidthAsPercent = (w: string): number => {
      const num = parseFloat(w);
      if (w.endsWith('vw')) return (num / 100) * window.innerWidth / gridWidth * 100;
      if (w.endsWith('px')) return num / gridWidth * 100;
      if (w.endsWith('rem')) {
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        return (num * rem) / gridWidth * 100;
      }
      if (w.endsWith('em')) {
        const em = parseFloat(getComputedStyle(document.body).fontSize);
        return (num * em) / gridWidth * 100;
      }
      if (w.endsWith('vh')) return (num / 100) * window.innerHeight / gridWidth * 100;
      return 0;
    };
  
    // Mảng lưu các cột có đơn vị phần trăm và cố định
    const percentCols: any[] = [];
    const fixedCols: any[] = [];
  
    // Duyệt qua tất cả cột để phân loại và cộng tổng phần trăm
    for (const h of visibleHeaders) {
      const w = h.width?.toString();
      if (!w || w === 'auto') continue;
  
      if (w.endsWith('%')) {
        percentCols.push(h);
        totalPercent += parseFloat(w);
      } else {
        fixedCols.push(h);
        totalPercent += getWidthAsPercent(w);
      }
    }
  
    // Tính phần trăm còn thiếu để tổng = 100%
    const missingPercent = 100 - totalPercent;
  
    if (missingPercent > 0) {
      // Nếu có từ 1 cột auto trở lên
      if (autoCols.length > 0) {
        const percentWidth = missingPercent / autoCols.length;
        autoCols.forEach(col => col.width = `${percentWidth.toFixed(2)}%`);
      }
  
      // Nếu không có auto nhưng có cột phần trăm
      else if (percentCols.length > 0) {
        const sum = percentCols.reduce((acc, h) => acc + parseFloat(h.width), 0);
        percentCols.forEach(h => {
          const original = parseFloat(h.width);
          h.width = ((original + (original / sum) * missingPercent).toFixed(2)) + '%';
        });
      }
  
      // Nếu chỉ có cột cố định
      else if (fixedCols.length > 0) {
        const sum = fixedCols.reduce((acc, h) => acc + getWidthAsPercent(h.width), 0);
        fixedCols.forEach(h => {
          if (h.fixedSize) return;
          const w = h.width.toString();
          const ratio = getWidthAsPercent(w) / sum;
          h.width = `calc(${w} + ${(ratio * missingPercent).toFixed(2)}%)`;
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.intervalHelper.stopInterval('autoPaging');

    if(this.subscribeFullscreenState) {
      this.subscribeFullscreenState.unsubscribe();
      this.subscribeFullscreenState = null;
    }   
    if(this.subscribeisLockPage) {
      this.subscribeisLockPage.unsubscribe();
      this.subscribeisLockPage = null;
    }
    this.gridResizeObserver?.disconnect();
    this.sync.reset();

  }

  genHeaderId(valueArr: any[]) {
    if(valueArr.length == 1) {
      return valueArr[0].title 
    }
    
    return valueArr.map(item => item.title).join('_');
  }

  getHeader():HeaderItemModel[]{
    let headers: HeaderItemModel[] = [];
    this._gridHeader?.forEach((header:any, index:number) => {
        if(header.subheader && header.subheader.length >0 && !header?.isSplitCell){
            header.subheader.map((sub:any) => {
                let headerItem = { 
                  field: `${this.genHeaderId(header.items)}_${index}`, 
                  title: header.items, 
                  dataType: header.dataType, 
                  visible: header.visible ?? true,
                  width: header.width, 
                  fixedSize: header.fixedSize,                  
                  textAlign: header.items.textAlign ?? 'center',
                  padding: header.items.padding ?? 'unset'
                };
                headers.push(headerItem)
            })
        } else {
            let headerItem = { 
                field: `${header.items[0].title}_${index}`, 
                title: header.items, 
                dataType: header.dataType, 
                fixedSize: header.fixedSize,
                visible: header.visible ?? true, width: header.width,
                textAlign: header.items.textAlign ?? 'center',
                padding: header.items.padding ?? 'unset'
              };
            headers.push(headerItem)
        }
       
     });
    return headers || [];
  }

  getSubHeader(): any[] {
    // Mảng chứa danh sách subheader sau khi xử lý
    let subHeaders: HeaderItemModel[] = []; 
    // Duyệt qua danh sách header trong `gridConfig.header`
    this._gridHeader?.map((header: any, index: number) => {
        // Kiểm tra xem header có `subheader` hay không và danh sách `subheader` có phần tử nào không
        if (header.subheader && header.subheader.length > 0) {
            // Nếu có subheader, duyệt qua danh sách subheader của header hiện tại
            header.subheader.map((sub: any) => {
                // Tạo đối tượng subheader với các thông tin cần thiết
                let headerItem = { 
                  // đánh index cho subheader
                  field: `${this.genHeaderId(sub.items)}_${index}`,
                  // Tiêu đề subheader
                  title: sub.items, 
                  // Kiểu dữ liệu của subheader thừa hưởng từ header cha
                  dataType: header?.dataType, 
                  // Nếu không có giá trị `visible`, mặc định là `true`
                  visible: header.visible ?? true, 
                  // Độ rộng của subheader (nếu có)
                  width: sub?.width, 
                  // Canh lề của subheader, mặc định là `center`
                  textAlign: sub.items.textAlign ?? 'center' ,

                  useComponent: sub.items.componentSubHeader ? true: false,
                  componentSubHeader: sub.items.componentSubHeader ?? null,
                  configSubHeader: sub.items.configSubHeader ?? null
                };

                subHeaders.push(headerItem);
            });
        } else {
            // Nếu không có subheader, sử dụng chính header đó làm header con
            let headerItem = {
              field: `${header.items[0].title}_${index}`, 
              // Tiêu đề header
              title: header.items, 
              // Kiểu dữ liệu
              dataType: header?.dataType, 
              // Nếu không có `visible`, mặc định là `true`
              visible: header.visible ?? true, 
              // Độ rộng của header
              width: header?.width, 
              // Canh lề, mặc định là `center`
              textAlign: header.items.textAlign ?? 'center' 
             
            };

            subHeaders.push(headerItem);
        }
    });

    return subHeaders || [];
  }

  getbodyData(body: any[]): any[][] {
    // Kiểm tra nếu body không tồn tại hoặc không phải mảng, trả về mảng rỗng
    if (!Array.isArray(body) || body.length === 0) return [];
  
    // Mảng chứa dữ liệu của toàn bộ bảng
    let bodyData: any[][] = [];
  
    // Kiểm tra `gridConfig.data` có tồn tại không, nếu không thì trả về []
    if (!Array.isArray(this._gridData) || this._gridData.length === 0) return [];
    this._gridData.forEach((data: any) => {
      // Mảng chứa dữ liệu của từng dòng
      let rowData: any[] = [];
      // Duyệt qua danh sách `body` để lấy thông tin từng ô trong hàng
      body.forEach((cell: any) => {
        var rawData = data?.[cell?.field] ?? null;
        var displayData = null;
        displayData = rawData;

        // Prepare config
        let cellConfig = cell?.config ?? {};

        // Add isShortTerm for UserInfoComponent
        if (this.processShortTerm && cell?.component === COMPONENT_NAME.UserInfoComponent) {
          const isShortTerm = BatheHelper.isShortTermUser(data, this.officeType);
          cellConfig = { ...cellConfig, isShortTerm, isBathScheduleScreen:this.isBathScheduleScreen };
        }
        rowData.push({
          // Loại component hiển thị trong ô
          component: cell?.component ?? null,  
          // Dữ liệu tương ứng, nếu không có thì là null
          data: displayData, 
          // Cấu hình component, nếu không có thì là object rỗng
          config: cellConfig, 
          // Giá trị `columnspan`, mặc định là 1 nếu không có
          columnspan: cell?.columnspan ?? 1 
        });
      });
  
      // Thêm dòng dữ liệu đã xử lý vào `bodyData`
      bodyData.push(rowData);
    });
    return bodyData;
  }
  getGroupBodyData(body: any[]): any[][] {
    let bodyFilter: any[] = cloneDeep(this.getBodyFilter());
    // Kiểm tra nếu body không tồn tại hoặc không phải mảng, trả về mảng rỗng
    if (!Array.isArray(body) || body.length === 0) return [];
    // Mảng chứa dữ liệu của toàn bộ bảng
    let bodyData: any[][] = [];
    // Kiểm tra `gridConfig.data` có tồn tại không, nếu không thì trả về []
    body.forEach((data: any) => {
      // Mảng chứa dữ liệu của từng dòng
      let rowData: any[] = [];
      // Duyệt qua danh sách `body` để lấy thông tin từng ô trong hàng
      bodyFilter.forEach((cell: any) => {
        // Prepare config
        let cellConfig = cell?.config ?? {};

        // Add isShortTerm for UserInfoComponent
        if (this.processShortTerm && cell?.component === COMPONENT_NAME.UserInfoComponent) {
          const isShortTerm = BatheHelper.isShortTermUser(data, this.officeType);
          cellConfig = { ...cellConfig, isShortTerm , isBathScheduleScreen:this.isBathScheduleScreen};
        }
        rowData.push({
          // Loại component hiển thị trong ô
          component: cell?.component ?? null,  
          // Dữ liệu tương ứng, nếu không có thì là null
          data: data?.[cell?.field] ?? null, 
          // Cấu hình component, nếu không có thì là object rỗng
          config: cellConfig, 
          // Giá trị `columnspan`, mặc định là 1 nếu không có
          columnspan: cell?.columnspan ?? 1 
        });
      });
  
      // Thêm dòng dữ liệu đã xử lý vào `bodyData`
      bodyData.push(rowData);
    });
    return bodyData;
  }

  getMergedHeaders() {
    // Lấy số hàng của headers
    let numRows = this.headers?.length || 0;
    // Lọc danh sách cột visible (chỉ giữ lại các cột có visible = true)
    let visibleHeaders = this.headers.map(row => row.filter(h => h.visible));
    // Lấy số cột sau khi lọc
    let numVisibleCols = visibleHeaders[0]?.length ?? 0;
    // Mảng chứa headers sau khi merge
    let mergedHeaders: any[][] = Array(numRows).fill(null)?.map(() => []);
    // Mảng đánh dấu các ô đã được merge để tránh xử lý trùng lặp
    let mergeMap: boolean[][] = Array(numRows).fill(null)?.map(() => Array(numVisibleCols)?.fill(false));
  
    // Duyệt từng hàng của headers
    for (let row = 0; row < numRows; row++) {
      // Duyệt từng cột của headers
      for (let col = 0; col < numVisibleCols; col++) {
        // Nếu ô này chưa bị merge
        if (!mergeMap[row][col]) {
          // Lấy thông tin ô hiện tại
          let cell = visibleHeaders[row][col];
          // Lấy giá trị hiển thị của ô
          let cellValue = typeof cell === 'object' ? cell?.title : cell; 
          // Canh lề của ô (nếu có)
          let textAlign = typeof cell === 'object' ? cell?.textAlign : 'center'; 
          // Số cột mà ô này sẽ merge ngang
          let colSpan = 1; 
          // Số hàng mà ô này sẽ merge dọc
          let rowSpan = 1; 
  
          //Merge ngang (gộp các ô có cùng giá trị ở cùng một hàng)
          for (let nextCol = col + 1; nextCol < numVisibleCols; nextCol++) {
            let nextCell = visibleHeaders[row][nextCol];
            let nextCellValue = typeof nextCell === 'object' ? nextCell.title : nextCell;

            // Nếu ô kế tiếp có cùng giá trị, tăng colSpan và đánh dấu đã merge
            if (nextCellValue === cellValue) {
              colSpan++;
              // Đánh dấu ô này đã được merge
              mergeMap[row][nextCol] = true; 
            } else {
              // Nếu khác giá trị thì dừng merge ngang
              break; 
            }
          }
  
          //Merge dọc (gộp các ô có cùng giá trị theo cột dọc)
          for (let nextRow = row + 1; nextRow < numRows; nextRow++) {
            let belowCell = visibleHeaders[nextRow][col];
            let belowCellValue = typeof belowCell === 'object' ? belowCell.title : belowCell;
  
            // Nếu ô bên dưới có cùng giá trị, tăng rowSpan và đánh dấu đã merge
            if (belowCellValue === cellValue) {
              rowSpan++;
              // Đánh dấu ô này đã được merge
              mergeMap[nextRow][col] = true; 
            } else {
              // Nếu khác giá trị thì dừng merge dọc
              break; 
            }
          }
  
          // Thêm ô đã merge vào danh sách kết quả
          mergedHeaders[row].push({ value: cellValue, colSpan, rowSpan, textAlign });
        }
      }
    }
    return mergedHeaders;
  }

  // tính chiều rộng của header group
  calculateGroupHeaderWidth(data: { width?: string | null }[] | null | undefined): string {
    if (!Array.isArray(data) || data.length === 0) return "auto";
  
    let totalVW = 0, totalPercent = 0, hasAuto = false;
  
    for (const item of data) {
      const width = item?.width?.trim();
      if (!width) continue;
  
      if (width === "auto") hasAuto = true;
      else if (width.endsWith("vw")) totalVW += parseFloat(width);
      else if (width.endsWith("%")) totalPercent += parseFloat(width);
    }
  
    return hasAuto ? "fit-content"
         : totalVW && totalPercent ? `calc(${totalVW}vw + ${totalPercent}%)`
         : totalVW ? `${totalVW}vw`
         : `${totalPercent}%`;
  }

  dataUpdate() {
    let bodyFilter: any[] = cloneDeep(this.getBodyFilter()) || [];
    // Lấy dữ liệu của bảng dựa vào danh sách cột visible
    if(this.isGroupData) {
      // tính chiều rộng của group header khi group các item mặc định lấy chiều rộng bằng chiều rộng 2 column đầu tiên
      if(!this.groupHeaderStyle) this.groupHeaderStyle = { 'width':  this.calculateGroupHeaderWidth(this._gridHeader?.slice(0, 2) || [])}
      // lấy data sau khi group
      this.groupedData = this.groupItemByGroupName();
    }
    else {
      this.groupItemSize = 0;
      this.isFirstUpdatePage = false;
      if(this.gridConfig) this.gridConfig.pageSize = this.gridConfig.pageSize || this.pageSizeDefault;
      this.bodyData = this.getbodyData(bodyFilter);
    }
    this.calcCellHeight();
    this.updateMinWidthTextMarquee();
  }

  groupItemByGroupName() {
    // tính số item trên 1 page khi có group data
    let gridData: any[] = this.getGroupItemInPage() || [];
    const groupedData = gridData?.reduce((groups: Record<string, any[]>, item: any) => {
      // Bỏ qua nếu thiếu groupName
      if (!item.groupName) return groups; 
  
      if (!groups[item.groupName]) {
        groups[item.groupName] = [];
      }
      groups[item.groupName].push(item);
  
      return groups;
    }, {});
    let newGroupData: any = this.updateIndexForGroupItems(groupedData) || {};
    // đổi newGroupData thành một mảng các cặp [groupName, items].
    return Object.entries(newGroupData).map(([groupName, items]) => ({
      groupName,
      items: this.getGroupBodyData(items as any[]),
    }));
  }

  // đánh lại index tăng dần cho các user trong cac group
  updateIndexForGroupItems(data: Record<string, any[]> | null | undefined) {
    if (!data || typeof data !== "object") return {};
    
    const updatedData: Record<string, any[]> = {};
    let currentPage = this.gridConfig?.currentPage || 0;
    let pageSize = this.gridConfig?.pageSize || 0;
    let currentIndex = (currentPage - 1) * pageSize + 1;
    Object.keys(data).forEach((key) => {
        if (!Array.isArray(data[key])) return;

        // Cập nhật lại dữ liệu cho nhóm tương ứng
        updatedData[key] = data[key]
            // Lọc bỏ các phần tử null hoặc undefined
            .filter((item) => item && typeof item === "object")
            .map((item) => {
                if (item.index === "休") {
                    currentIndex++;
                    // Giữ nguyên "休"
                    return { ...item, index: "休" }; 
                }
                // Nếu không phải "休", gán index tăng dần
                return { ...item, index: currentIndex++ };
          });
    });
    return updatedData;
  }
  
  getBodyFilter() {
    let headerDistinct = this.mergeHeaders(this.headers[0]);
    // Lấy danh sách index của các cột có `visible = true`
    let visibleIndexes: number[] = headerDistinct
        // Nếu visible = true thì giữ lại index, ngược lại trả về -1
        .map((h, index) => h.visible ? index : -1) 
        // Loại bỏ các index có giá trị -1 (tức là những cột bị ẩn)
    .filter(index => index !== -1); 
    return this.filterByIndexes(visibleIndexes, this._gridHeader || []);
  }

  // Lọc mảng body, chỉ giữ lại các phần tử có index nằm trong mảng visibleIndexes
  filterByIndexes(visibleIndexes: number[], body: any[]): any[] {
    if (!Array.isArray(visibleIndexes) || !Array.isArray(body)) return [];
    return body.filter((_, index) => visibleIndexes?.includes(index));
  }

  // Gộp các header có chung field name thành một mảng header duy nhất
  mergeHeaders(headers: any[]): any[] {
    // Nếu headers không tồn tại hoặc là mảng rỗng, trả về mảng rỗng ngay lập tức
    if (!headers || headers?.length == 0) return [];

    // Sử dụng Map để lưu các cột đã xuất hiện (tránh trùng lặp)
    let mergedMap = new Map<string, any>(); 

    // Mảng kết quả chứa các header sau khi gộp
    let mergedHeaders: any[] = [];

    // Duyệt qua từng phần tử trong headers
    headers.forEach(header => {
      // Nếu field chưa tồn tại trong Map, thêm vào Map và mảng kết quả
      if (!mergedMap.has(header.field)) {
        // Lưu vào Map để đánh dấu đã xuất hiện
        mergedMap.set(header.field, header); 
        // Thêm vào danh sách headers hợp nhất
        mergedHeaders.push(header); 
      }
    });
    // Trả về danh sách headers đã loại bỏ các field trùng lặp
    return mergedHeaders;
  }

  isTriggerSortData: boolean = false;

  paginationConfig() {
    this.displayPagination.emit({pageNum: (this.gridConfig?.currentPage || 1), totalPage: this.gridConfig?.totalPage || 1});
    if(!this.isTriggerSortData) {
      this.onTriggerSortData.emit(this.gridConfig);
      this.isTriggerSortData = true;
    }
  }

  configGridSetting() {
    if(!this.gridConfig) return;
    this.gridConfig.pageSize = this.gridConfig.pageSize || this.pageSizeDefault;
    this.gridConfig.totalPage = Math.ceil(this.originData.length / this.gridConfig.pageSize);
    this.paginationConfig();
  }

  getDataInPage() {
    if(!this.gridConfig) this.gridConfig  = new GridConfigModel();
    this.handlerGridDataBeforePaging();
    this.dataUpdate();
  }

  handlerGridDataBeforePaging(){
    if (this.isGroupData) {
      // nếu data đang group thì lấy toàn bộ originData để tiến hành phân trang từ đầu.
      this._gridData = this.originData;
    } else {
      // nếu không group thì thì lấy data theo từng page với pagesize mặc định là 10.
      this._gridData = this.getCurrentPageData() || [];
    }
  }

  paginationGridData(reloadData: boolean = true) {
    if (reloadData) this.getDataInPage();
    // nếu total page > 1 thì call hàm change page
    if(this.gridConfig && this.gridConfig?.totalPage > 1) this.onChangePage();
  }

  onChangePage() {
    this.intervalHelper.stopInterval('autoPaging');
    
    const handleAutoPaging = () => {
      if(!this.gridConfig) return;
      this.gridConfig.currentPage++;
      if (this.gridConfig.currentPage > this.gridConfig.totalPage) {
        this.gridConfig.currentPage = 1;
      }
      this.handlerGridDataBeforePaging();
      this.dataUpdate();
      this.paginationConfig();
      setTimeout(() => { this.dpadControlService.setdXdYMainScreen(0, 0) });
    };

    const delay = this.gridConfig?.intervalTime ?? 30000

    this.intervalHelper.startInterval('autoPaging', handleAutoPaging, delay);
  }

  getCurrentPageData() {
    if(!this.gridConfig) return;
    this.gridConfig.currentPage = this.gridConfig.currentPage ? this.gridConfig.currentPage  : 1;
    const startIndex = (this.gridConfig.currentPage - 1) * this.gridConfig.pageSize;
    const endIndex = startIndex + this.gridConfig.pageSize;
    return this.originData.slice(startIndex, endIndex);
  }

  updateMinWidthTextMarquee() {
    if(!this.gridConfig) return;
    
    let maxWidthByIndex: Record<number, number> = {};
    
    const processItems = (items: any[]) => {
      items.forEach((item: any, index) => {
        if (item.component === COMPONENT_NAME.TextMarqueeComponent) {
          let message = '';
          if(Array.isArray(item.data) && item.data.length) {
            if(item.data[0].isMapByType) {
              const result = [...new Set(item.data.map((d:any) => d.type_name))]
              .map(type => `${type}：${item.data.filter((d:any) => d.type_name === type).map((d:any) => d.message).join(" ")}`)
              .join(" 、");
              message =  result;
            } else {
              message = item.data.map((x: any) => `${x.message}`).join(" ");
            }
          } else {
            message = item?.data?.message;
          }
          if (message) {
            const textWidth = this.getTextWidth(message);
            maxWidthByIndex[index] = Math.max(maxWidthByIndex[index] || 0, textWidth);
          }
        }
      });
    };
    
    const updateMinWidth = (items: any[]) => {
      items.forEach((item: any, index) => {
        if (item.component === COMPONENT_NAME.TextMarqueeComponent && maxWidthByIndex[index]) {
          item.config.minWidth = `${maxWidthByIndex[index]}px`;
        }
      });
    };

    if (this.isGroupData) {
      this.groupedData.forEach(group => group.items.forEach(processItems));
      this.groupedData.forEach(group => group.items.forEach(updateMinWidth));
    } else {
      this.bodyData.forEach(processItems);
      this.bodyData.forEach(updateMinWidth);
    }
  }

  private textMeasureContext: CanvasRenderingContext2D | null = null;
  getTextWidth(text: string): number {
    if (!this.textMeasureContext) {
      const canvas = document.createElement('canvas');
      this.textMeasureContext = canvas.getContext('2d');
      this.textMeasureContext!.font = '1.5vw sans-serif';
    }
  
    return this.textMeasureContext!.measureText(text).width;
  }
}
